export default function () {
    document.addEventListener('DOMContentLoaded', () => {
        const $modal = document.querySelectorAll('.domainnavigation-popup-trigger');

        if (!$modal) {
            return;
        }

        // eslint-disable-next-line
        Array.prototype.slice.call($modal).forEach(function ($modal) {
            // eslint-disable-next-line
            $modal.addEventListener('click', () => {
                const id = $modal.dataset.domainnavigationpopup;
                const selectedModal = document.querySelector(id);
                selectedModal.classList.add('show');
            }, false);
        });

        const $modalClose = document.querySelectorAll('.domainnavigation-popup-trigger-close');

        // eslint-disable-next-line
        Array.prototype.slice.call($modalClose).forEach(function ($modalClose) {
            // eslint-disable-next-line
            $modalClose.addEventListener('click', () => {
                const id = $modalClose.dataset.domainnavigationpopupclose;
                const selectedModal = document.querySelector(id);
                selectedModal.classList.remove('show');
            }, false);
        });
    });
}
